// tslint:disable: no-invalid-template-strings
import { ActionType, createAction } from 'typesafe-actions';
import { IListObjectStore } from '../../_common/type';
import {
    EBFL2RecordCode,
    TBFL2BackendRecord,
    TBFL2HistoryFilters,
} from './@types';

enum EBFL2Constants {
    FEATURE = '@bfl2',
    // API = '/bfl2',
    API = '/api/marpol/all',
}
enum EBFL2Actions {
    HISTORY_LOAD = '@bfl2/:history-load',
   
    HISTORY_SET = '@bfl2/${history}/set',

    GOTO_DASHBOARD = '@bfl2/-->dashboard',
    GOTO_OPERATION_DASHBOARD = '@bfl2/-->operation-dashboard',
    GOTO_SELECTED_OPERATION = '@bfl2/-->selected-operation',
    GOTO_HISTORY = '@bfl2/-->history',

    SET_FILTER = '@bfl2/:set-filter',
}

const bfl2Actions = {
    commands: {
        historyLoad: createAction(
            EBFL2Actions.HISTORY_LOAD,
            (providedFilters: TBFL2HistoryFilters) => ({
                providedFilters,
            })
        )(),
    },
    document: {
        historySet: createAction(
            EBFL2Actions.HISTORY_SET,
            (history: IListObjectStore<TBFL2BackendRecord>) => ({
                history,
            })
        )(),
        setFilter: createAction(EBFL2Actions.SET_FILTER, (filter: any) => ({
            filter,
        }))(),
    },
    routes: {
        gotoDashboard: createAction(EBFL2Actions.GOTO_DASHBOARD)(),
        gotoOperationDashboard: createAction(
            EBFL2Actions.GOTO_OPERATION_DASHBOARD
        )(),
        gotoSelectedOperation: createAction(
            EBFL2Actions.GOTO_SELECTED_OPERATION,
            (operationCode: EBFL2RecordCode) => ({ operationCode })
        )(),
        gotoHistory: createAction(EBFL2Actions.GOTO_HISTORY)(),
    },
    events: {},
};

export type TBFL2Actions = ActionType<typeof bfl2Actions>;
export default bfl2Actions;
export { EBFL2Constants, EBFL2Actions };
